/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Exercise_Sheet_Range_1yInputs */

const en_us2_exercise_sheet_range_1y = /** @type {(inputs: Exercise_Sheet_Range_1yInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`1Y`)
};

const pt_br2_exercise_sheet_range_1y = /** @type {(inputs: Exercise_Sheet_Range_1yInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`1A`)
};

const es_419_exercise_sheet_range_1y = /** @type {(inputs: Exercise_Sheet_Range_1yInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`1A`)
};

const pt_pt2_exercise_sheet_range_1y = /** @type {(inputs: Exercise_Sheet_Range_1yInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`1A`)
};

const fr_fr2_exercise_sheet_range_1y = /** @type {(inputs: Exercise_Sheet_Range_1yInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`1A`)
};

const de_de2_exercise_sheet_range_1y = /** @type {(inputs: Exercise_Sheet_Range_1yInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`1J`)
};

const it_it2_exercise_sheet_range_1y = /** @type {(inputs: Exercise_Sheet_Range_1yInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`1A`)
};

/**
* | output |
* | --- |
* | "1Y" |
*
* @param {Exercise_Sheet_Range_1yInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const exercise_sheet_range_1y = /** @type {((inputs?: Exercise_Sheet_Range_1yInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Exercise_Sheet_Range_1yInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_exercise_sheet_range_1y(inputs)
	if (locale === "es-419") return es_419_exercise_sheet_range_1y(inputs)
	if (locale === "pt-PT") return pt_pt2_exercise_sheet_range_1y(inputs)
	if (locale === "fr-FR") return fr_fr2_exercise_sheet_range_1y(inputs)
	if (locale === "de-DE") return de_de2_exercise_sheet_range_1y(inputs)
	if (locale === "it-IT") return it_it2_exercise_sheet_range_1y(inputs)
	return en_us2_exercise_sheet_range_1y(inputs)
});
export { exercise_sheet_range_1y as "exercise-sheet.range_1y" }